import { render, staticRenderFns } from "./shopping-detail.vue?vue&type=template&id=1107caf4&"
import script from "./shopping-detail.vue?vue&type=script&lang=js&"
export * from "./shopping-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports